import type { AdvertiserJobAccess } from '../../../graphql/fetchAccessAndJobInformationByPositionId';
import { navigateToAccountSelectionPage } from './utils';
import type { IStore } from '../../../stores/Store';
import { AccessType } from '../../../stores/JobStore/types';

export const handleAdvertiserPositionAccess = (
  store: IStore,
  id: number,
  access: AdvertiserJobAccess | null,
) => {
  const accessType = access?.accessType ?? AccessType.NOT_FOUND;
  store.jobStore.setAccessType(accessType);
  if (accessType === AccessType.INCORRECT_ADVERTISER) {
    if (access?.correctAdvertiserId) {
      navigateToAccountSelectionPage();
    } else {
      throw new Error('access.correctAdvertiserId missing');
    }
  }
};
